import { ClinicalCareEventStatus } from '~/types';

const translations = {
  screening: 'Triagem',
  forwarded: 'Encaminhado',
  hospitalized: 'Internado',
  medicalRelease: 'Alta médica',
  death: 'Falecido',
  pullout: 'Em retirada',
  caught: 'Saída',
  done: 'Concluído',
  canceled: 'Cancelado',
  recordAdded: 'Prontuário atualizado',
  prescritionAdded: 'Receita adicionada',
};

export default function clinicalCareEventStatus(status: ClinicalCareEventStatus): string {
  return translations[status] || status;
}
